import { Link } from 'react-router-dom'
import { useAuth } from '../../../../app/modules/auth'
import { useInactivityContext } from '../../../../app/modules/auth/inatividade/InactivityContext'
import { SessionCountdownBadge } from '../../../../app/modules/auth/inatividade/SessionCountdownBadge'
import { KTSVG, MenuPaths, toAbsoluteUrl } from '../../../helpers'

const AsideToolbar = () => {
  const { currentUser } = useAuth()
  const { status, remainingSeconds, enabled } = useInactivityContext()

  const imageDefault = '/media/avatars/blank.png'
  const imagePerfil = toAbsoluteUrl(String(currentUser?.imagemPerfil))
  const hasImage = currentUser?.imagemPerfil !== null

  return (
    <div className='aside-user d-flex align-items-sm-center justify-content-center py-5'>
      <div className='symbol symbol-50px'>
        <img src={hasImage ? imagePerfil : imageDefault} alt='Imagem do Perfil' />
      </div>

      <div className='aside-user-info'>
        <Link to='/crafted/account/overview' className='aside-user-link'>
          <span className='aside-user-name' title={currentUser?.pessoa?.nome}>
            {currentUser?.pessoa?.nome}
          </span>
          <KTSVG path={MenuPaths.Editar_Perfil} className='aside-user-edit' />
        </Link>

        {enabled && status !== 'bloqueado' && (
          <SessionCountdownBadge remainingSeconds={remainingSeconds} status={status} />
        )}
      </div>
    </div>
  )
}

export { AsideToolbar }
